import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';

const LandingPage = () => {
    const { user } = useAuth();


    return (
        <div className="bg-brand-dark text-white font-custom">
            <header id="header" className="fixed top-0 left-0 right-0 z-50 bg-black/30 backdrop-blur-md">
                <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                    <Link to="/" id="logo" className="flex items-center">
                        <h1 className="text-3xl font-extrabold text-brand-lime tracking-tighter">5.AM</h1>
                        <span className="text-xl font-semibold text-white ml-2 tracking-wide">Padel Club</span>
                    </Link>
                    <div id="header-actions" className="flex items-center space-x-4">
                        {user ? (
                            <Link to="/dashboard" className="bg-brand-lime text-brand-dark font-bold py-2 px-6 rounded-full hover:bg-opacity-90 transition duration-300 transform hover:scale-105">Dashboard</Link>
                        ) : (
                            <>
                                <Link to="/login" className="text-white hover:text-brand-lime transition duration-300 cursor-pointer">Masuk</Link>
                                <Link to="/login" className="bg-brand-lime text-brand-dark font-bold py-2 px-6 rounded-full hover:bg-opacity-90 transition duration-300 transform hover:scale-105">Jadi Anggota</Link>
                            </>
                        )}
                    </div>
                </div>
            </header>

            <main>
                <section id="features-section" className="py-24 bg-brand-dark">
                    <div className="container mx-auto px-6">
                        <div className="grid md:grid-cols-2 gap-16">
                            <div className="flex flex-col items-start">
                                <div className="mb-6">
                                    <i className="fa-solid fa-bolt text-6xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-extrabold text-brand-lime uppercase mb-4 tracking-wider">More Than a Club — It’s a Movement</h3>
                                <p className="text-white text-lg leading-relaxed">
                                    We are not just a club, we are a movement. We are a community of passionate padel players who are committed to making a better life through padel.
                                </p>
                            </div>

                            <div className="flex flex-col items-start">
                                <div className="mb-6">
                                    <i className="fa-solid fa-wand-magic-sparkles text-6xl text-white"></i>
                                </div>
                                <h3 className="text-2xl font-extrabold text-brand-lime uppercase mb-4 tracking-wider">Smart Club Experience</h3>
                                <p className="text-white text-lg leading-relaxed">
                                    We have a smart club experience where you can track your progress, and get the most out of your time at the club.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <footer id="footer" className="bg-black">
                <div className="container mx-auto px-6 py-12">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                        <div id="footer-brand" className="col-span-1 md:col-span-2">
                            <Link to="/" className="flex items-center">
                                <h1 className="text-3xl font-extrabold text-brand-lime tracking-tighter">5.AM</h1>
                                <span className="text-xl font-semibold text-white ml-2 tracking-wide">Padel Club</span>
                            </Link>
                            <p className="mt-4 text-gray-400 max-w-md">Because Growth Never Sleeps.</p>
                            <div className="mt-6 flex items-center gap-6">
                                <a href="https://reclub.co/clubs/@5ampadelclub" target="_blank" rel="noopener noreferrer" className="group text-gray-400 hover:text-brand-lime cursor-pointer transition-colors duration-300">
                                    <div
                                        className="w-6 h-6 bg-current"
                                        style={{
                                            maskImage: 'url("/images/reclub-logo.png")',
                                            maskSize: 'contain',
                                            maskRepeat: 'no-repeat',
                                            maskPosition: 'center',
                                            WebkitMaskImage: 'url("/images/reclub-logo.png")',
                                            WebkitMaskSize: 'contain',
                                            WebkitMaskRepeat: 'no-repeat',
                                            WebkitMaskPosition: 'center'
                                        }}
                                        aria-label="Reclub"
                                    />
                                </a>
                                <a href="https://www.instagram.com/5ampadelclub" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-lime cursor-pointer transition-colors duration-300 flex items-center justify-center">
                                    <i className="fa-brands fa-instagram text-2xl leading-none"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="mt-12 border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
                        <p>© {new Date().getFullYear()} 5AM Padel Club. Hak Cipta Dilindungi.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;
